import {debounce} from '../../../utils/decorators/debounce'
import {getVideos} from './services';

let notEmpty = false;

const resultSearchWords = {
	empty: `<h2>Ничего не&nbsp;найдено</h2>`,
	success: `Результаты поиска`,
}

const scrollObserver = ( elem ) => {
	if ( window.scrollY > 2 )
	{
		elem.classList.add( 'visible' );
	}
	else
	{
		elem.classList.remove( 'visible' );
	}
}

const getVideo = ( header ) => {
	const wrapper = header.querySelector( 'div.search' );
	const input = header.querySelector( 'div.search-wrapper input' );
	const clearBtn = header.querySelector( 'svg.clear' );

	const scrollTopBtn = document.querySelector( 'button.to-top' );

	setTimeout( () => {
		const input = header.querySelector('div.search-wrapper input');
		input.focus();
	}, 0 );

	const recommendedResult = () => {
		getVideos( '' )
		.then( ( data ) => {
			if ( data.rendered )
			{
				wrapper.innerHTML = data.rendered;

				if ( data.video && Object.keys( data.video ).length > 8 )
				{
					wrapper.classList.add( 'more' );
				}
				else
				{
					wrapper.classList.remove( 'more' );
				}

				if ( scrollTopBtn )
				{
					scrollTopBtn.addEventListener( 'click', () => {
						window.scrollTo({ top: 0, behavior: 'smooth' });
					} );

					window.addEventListener( 'scroll', () => scrollObserver( scrollTopBtn ) );
				}
			}
		} );
	}

	if ( input.value == '' )
	{
		recommendedResult();
	}

	clearBtn.addEventListener( 'click', ( evt ) => {
		input.value = '';
		notEmpty = false;
		clearBtn.classList.remove( 'active' );
	} );

	const handleInput = ( evt ) => {
		if ( evt.target.value === '' )
		{
			notEmpty = false;
			clearBtn.classList.remove( 'active' );
		}
		else
		{
			notEmpty = true;
			clearBtn.classList.add( 'active' );
		}

		if ( evt.target.value.length < 3 )
		{
			recommendedResult();
			return;
		}
		
		getVideos( evt.target.value ).then( ( data ) => {
			if ( data.rendered )
			{
				wrapper.innerHTML = data.rendered;

				header.querySelector( 'div.search h2' ).innerHTML = resultSearchWords.success;

				if ( data.video && Object.keys( data.video ).length > 8 )
				{
					wrapper.classList.add( 'more' );
				}
				else
				{
					wrapper.classList.remove( 'more' );
				}
			}
			else
			{
				wrapper.innerHTML = resultSearchWords.empty;
			}

			if ( scrollTopBtn )
			{
				scrollTopBtn.addEventListener( 'click', () => {
					window.scrollTo({ top: 0, behavior: 'smooth' });
				} );

				window.addEventListener( 'scroll', () => scrollObserver( scrollTopBtn ) );
			}
		} );
	}

	const debouncedHandle = debounce( handleInput, 250 );

	input.addEventListener( 'input', debouncedHandle );
};

export {
	getVideo,
};
